import React from 'react'
import { useAuth } from 'providers/authProvider'
import { Redirect, Route } from 'react-router-dom'

export function PrivateRoute({ children, ...rest }) {
  const { user } = useAuth()

  return (
    <Route
      {...rest}
      render={({ location }) =>
        user ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/auth/signin',
              state: { from: location },
            }}
          />
        )
      }
    />
  )
}
